const NULL_PLACEHOLDER = '-';
const MAX_DECIMALS = 6;

/**
 * Formats a numeric grid value: rounds to `maxDecimals` then trims trailing zeros.
 * Returns '-' for nullish or non-finite inputs. The decimal point is deliberate and
 * locale-independent, so grids, graph tooltips and the publication email agree.
 */
export const formatNumericValue = (value: number | null | undefined, maxDecimals = MAX_DECIMALS): string => {
  if (value == null || !Number.isFinite(value)) return NULL_PLACEHOLDER;
  return Number(value.toFixed(maxDecimals)).toString();
};

/** Clipboard variant: blank instead of the on-screen '-' so Excel receives empty cells. */
export const formatClipboardNumericValue = (value: number | null | undefined): string => {
  const formatted = formatNumericValue(value);
  return formatted === NULL_PLACEHOLDER ? '' : formatted;
};
